import { FC, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { EventWrapperProps } from 'react-big-calendar';

import { useLanguageContext } from 'store/language';

import { getEventStyleColleague } from 'utils/helpers/leaves';

import TooltipWrapper from 'components/TooltipWrapper';

interface Props extends EventWrapperProps {
  event: any;
  continuesAfter?: boolean;
}

const CustomEventWrapper: FC<Props> = ({ event, continuesAfter }: Props) => {
  const { t } = useTranslation();
  const { language } = useLanguageContext();
  const isLanguageEN = language === 'en';

  const [classNames, setClassNames] = useState('');

  useEffect(() => {
    const updateClassNames = () => {
      if (window.innerWidth < 1600) {
        setClassNames('d-flex justify-content-center pr-5 pl-2 pt-2');
      } else {
        setClassNames('d-flex justify-content-center pr-3 pt-4');
      }
    };

    // Set the class names initially
    updateClassNames();

    // Listen for window resize events
    window.addEventListener('resize', updateClassNames);

    // Cleanup listener when component is unmounted
    return () => {
      window.removeEventListener('resize', updateClassNames);
    };
  }, []);

  const isEventHoliday = event.type === 'holiday';

  const eventOverlay = isEventHoliday ? (
    `${t(`leaves.${event.type}`)} ${' - '} ${isLanguageEN ? event.name_en || '' : event.name}`
  ) : (
    // We need span here, to add `<br />` element, so we can render the comment on a new line
    <>
      <span>{event.user_name}</span>
      <br />
      <span>{event.comment ? `${t('leaves.comment')}: ${event.comment}` : t('leaves.noComment')}</span>
    </>
  );

  const eventName = isEventHoliday ? (isLanguageEN && event.name_en) || event.name : event.user_name;
  const isHalfDay = event.leave_days === 1;

  if (!continuesAfter) {
    return (
      <div
        className="d-flex justify-content-between pr-2 pl-2 w-100 overflow-hidden"
        style={getEventStyleColleague(event)}
      >
        <TooltipWrapper
          id="tooltip-calendar-event"
          overlay={eventOverlay}
          wrapperClass="d-block d-flex justify-content-between w-auto"
        >
          <EventName className="mb-0">{eventName}</EventName>
        </TooltipWrapper>
        <div style={{ minWidth: '46px', textAlign: 'end' }} />
        {isHalfDay && (
          <TooltipWrapper
            id="tooltip-calendar-event"
            overlay={`${t('leaves.requestedHalfDay')} - ${t(`leaves.${event.type}`)}`}
            wrapperClass="pl-1"
          >
            <span style={{ lineHeight: '15px', display: 'block', padding: '4px 0 0' }}>&#xBD;</span>
          </TooltipWrapper>
        )}
      </div>
    );
  }

  return (
    <div
      className="d-flex justify-content-between pr-2 pl-2 overflow-hidden"
      style={getEventStyleColleague(event)}
    >
      <EventName className="mb-0">
        {/** @ts-ignore */}
        {eventName}
      </EventName>
    </div>
  );
};

export default CustomEventWrapper;

const EventName = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
